import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Box, Typography, IconButton
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getIcon } from '../../../utils/IconHandler';

const PDFViewerModal = ({ open, onClose, order, pdfUrl }) => {
  const { t } = useTranslation();

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="lg" 
      fullWidth
      PaperProps={{
        sx: { height: '90vh' }
      }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6">
          {t('invoice')} - {order?.orderNumber}
        </Typography>
        <IconButton onClick={onClose} size="small">
          {getIcon('close')}
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 0, height: '100%' }}>
        {pdfUrl && (
          <Box sx={{ height: '100%', width: '100%' }}>
            <iframe
              src={pdfUrl}
              width="100%"
              height="100%"
              style={{ border: 'none' }}
              title={`Factura ${order?.orderNumber}`}
              type="application/pdf"
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          {t('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PDFViewerModal;
